import { RESET_VALUES } from '../actionTypes';
import { projectActions } from '../reducer';

export default () => projectActions[RESET_VALUES]();
